/**
 * What to refresh after a prepared-drop changed — in one place.
 * For Media Devoted | Created By Ciro Autiero
 *
 * Every mutation used to invalidate the list prefix by hand. That was fine
 * until the undo status joined it: the "Undo last change" button is driven by a
 * separate query, and a mutation that refreshed only the list left the button
 * stale — an edit was undoable, but nothing said so until the next poll.
 *
 * One helper means the next mutation someone adds cannot forget half of it.
 */

import type { QueryClient } from '@tanstack/react-query';

import { PREPARED_DROPS_UNDO_KEY } from '@/features/prepared-drops-undo';

import { smswiserCampaignWorkspaceKeys as keys } from './keys';

/** Refresh the drops of a country plus the undo affordance they feed. */
export function invalidatePreparedDrops(
  qc: QueryClient,
  countryKey: string,
): void {
  qc.invalidateQueries({
    queryKey: keys.preparedDropsByCountryPrefix(countryKey),
  });
  qc.invalidateQueries({ queryKey: PREPARED_DROPS_UNDO_KEY });
}
